import { Modal, ModalBody, Spinner } from "reactstrap";
import ErrorMessage from "./ErrorMessage";
import { useState } from "react";
import DeleteIcon from "../Icons/DeleteIcon";
import CrossIcon from "../Icons/CrossIcon";

const ConfirmModal = ({ modal, toggle, submitHandler, isLoading, Reason }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const handleSubmit = () => {
    if (Reason) {
      if (reason.length === 0) {
        setError("Reason is required");
        return;
      }
      submitHandler(reason);
    } else {
      submitHandler();
    }
  };

  const closeHandler = () => {
    toggle();
  };

  return (
    <Modal isOpen={modal} toggle={closeHandler} centered>
      <ModalBody className="text-center ">
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span className="icon">
            {Reason ? <CrossIcon /> : <DeleteIcon />}
          </span>

          {/* {!Reason && <h2>Are you sure ?</h2>} */}
          <p className="mb-4">
            Do you really want to {Reason ? "Reject" : "delete"} ?
          </p>
          {Reason && (
            <div className="col-12">
              <div className="d-flex flex-column">
                <label htmlFor="firstName" className="form-label text-start">
                  Reason
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control w-100"
                  placeholder="Reason"
                  id="firstName"
                  aria-describedby="emailHelp"
                  onChange={(e) => {
                    if (e.target.value) {
                      setReason(e.target.value);
                      setError("");
                    }
                  }}
                />
                <ErrorMessage message={error} />
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={closeHandler}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <button
                className="btn btn-danger w-100"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner color="light" />
                ) : Reason ? (
                  "Reject"
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmModal;
